import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dueDateStatus' })
export class DueDateStatusPipe implements PipeTransform {
  transform(processingDeadline: Date | string): string {
    const today = new Date();
    const dueDate = new Date(processingDeadline);
    const differenceInTime = dueDate.getTime() - today.getTime();
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

    const datepipe: DatePipe = new DatePipe('en-US');
    const formattedDate = datepipe.transform(dueDate, 'dd MMM, YYYY - HH:mm');

    return `<span class="text-${
      differenceInDays < 1
        ? 'danger'
        : differenceInDays >= 1 && differenceInDays < 3
        ? 'warning'
        : 'dark'
    }">${formattedDate}</span>`;
  }
}
